import type {Result, UseCase} from 'framework';
import type {AuthRepository, ChangePasswordData} from '../ports/auth.repository';
import type {ChangePasswordError} from '../../domain/errors';

export class ChangePassword implements UseCase<[ChangePasswordData], undefined> {
  constructor(private readonly authRepository: AuthRepository) {}

  execute(data: ChangePasswordData): Promise<Result<undefined, ChangePasswordError>> {
    return this.authRepository.changePassword(data);
  }
}
